import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class VerbisIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchStatus() {
        try {
            const response = await this.service.getStatus();
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async openExport() {
        try {
            const response = await this.service.getExport();
            const blob = response.data instanceof Blob
                ? response.data
                : new Blob([response.data], { type: 'text/html;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener');
            setTimeout(() => URL.revokeObjectURL(url), 60_000);
            return { success: true };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async markSynced(note) {
        try {
            const response = await this.service.markSynced({ note });
            toast.success(
                i18next.t('gdprVerbis:messages.syncSuccess', { defaultValue: 'VERBIS sync recorded' }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    _getErrorMessage(error) {
        return getIntegrationErrorMessage(error);
    }
}
